import { Component } from 'react';

import { IOC_TYPES } from '../../context/ioc.types';
import { lazyInject } from '../../context/module';
import { EnvironmentService } from '../../services/environment.service';
import MotiveFrame from '../motive-frames/motive-frame.component';
import { pageCopy } from '../ui/page-copy/page-copy';
import styles from './faq.component.module.scss';

export default class FAQComponent extends Component<any> {
    faqEnabled = true;

    @lazyInject(EnvironmentService) private envService: EnvironmentService;

    constructor(props) {
        super(props);
        this.faqEnabled = this.envService.isXConvert();
    }

    render() {
        if (!this.faqEnabled) {
            return null;
        }

        // H1, intro and the question list = SSR page data (xconvert-web-ssr sources/page-data-overrides/faq.json).
        const { seo, content: c } = pageCopy(this.props);
        return <MotiveFrame>
            <div className={styles['wrapper']}>
                <div className={styles['main-card']}>
                    <div className={styles['header']}>
                        <h1 className={styles['title']}>{c.h1 || seo.title}</h1>
                        <p className={styles['description']}>{seo.description}</p>
                    </div>

                    <ol className={styles['faq']}>
                        {(c.questions || []).map((q: any) => <li key={q.href}>
                            <a href={q.href}>{q.text}</a>
                        </li>)}
                    </ol>
                </div>
            </div>
        </MotiveFrame>
    }
}
